import axios from 'axios'
import Config from '../config'

export default( ) => {
	return axios.create( {
		baseURL: Config.hsws.baseUrl,
		headers: {
			common: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-sirs-clientID': Config.hsws.clientId,
				'sd-originating-app-id': Config.hsws.originatingAppId
			}
		}
	} );
}
